import { ANKR_DOCS_LINKS } from 'modules/common/constants/const';
import { Locale } from 'modules/i18n';

export const aapiPricingTableTranslation = {
  [Locale.en]: {
    header: {
      method: 'Method',
      apiCredits: 'API Credits/request',
      usd: 'USD/request',
    },
    method: {
      text: 'All supported methods',
      link: ANKR_DOCS_LINKS.aapiSupportedMethods,
    },
    apiCredits: '700',
    usd: '$0.00007',
  },
};
